  <h2 class="font-weight-bold">{{ 'FILTER_SEARCH_CROSS_REFERENCE' | translate }}</h2>

  <div class="cross-reference-search-container bg-secondary">
    <label for="filter-search-cross-reference-input" class="form-label text-white">{{ 'SEARCH_FOR_THE_ITEM_NUMBER_OF_YOUR_FILTER' | translate }}</label>
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        id="filter-search-cross-reference-input"
        aria-describedby="filter-search-cross-reference-search-button"
        [(ngModel)]="searchInput"
        (ngModelChange)="onSearchInputChanged()"
        (keyup.enter)="search()">
      <button class="btn btn-primary" type="button" id="filter-search-cross-reference-search-button" (click)="search()">{{ 'SEARCH' | translate }}</button>
    </div>
    @if (!!minLengthError) {
      <div class="mt-1">
        <small class="text-danger font-weight-bold">* {{ 'FORM_ERROR_MIN_LENGTH' | translate : { actualLength: searchInput.length, requiredLength: 3 } }}</small>
      </div>
    }
  </div>

  @if (firstSearch) {
    <div class="row mt-3">
      <div class="col-12">
        <otto-olsen-filter-list [configService]="configService"></otto-olsen-filter-list>
      </div>
    </div>
  }
